import { apiClient } from "@/api/apiClient";

export const getCurrentAccount = async (accountId: number) => {
  const account = await apiClient().get(`/accounts/${accountId}`);
  return account;
};

type NotificationSettingsBody = {
  [key: string]: any;
};

export const updateAccount = async (
  accountId: number,
  body: NotificationSettingsBody,
) => {
  const { data } = await apiClient().put(
    `/accounts/${accountId}/notificationSettings`,
    body,
  );
  return data;
};
